import React, { FC } from 'react'
import { Box, Spinner } from 'front-end/src/components'
import { useCachedWorkspacesQuery } from 'front-end/src/app/stores/useCachedWorkspacesQuery'
import { Trans } from '@lingui/macro'
import { AdminOnlyAllowed } from 'front-end/src/components/common/AdminOnlyAllowed'
import { CreateWorkspaceButtonModal } from 'front-end/src/components/navigation/CreateWorkspaceButtonModal'
import { buildWorkspaceCategoryTree } from 'front-end/src/pages/workspace-page/buildWorkspaceCategoryTree'
import { NavigationWorkspaceCategoryItem } from './NavigationWorkspaceCategoryItem'
import { WorkspaceAccordionItem } from './NavigationWorkspaceAccordionItem'

type NavigationWorkspacesProps = {
  hideNavigation: () => void
}

export const NavigationWorkspaces: FC<NavigationWorkspacesProps> = ({
  hideNavigation
}) => {
  const { data, loading } = useCachedWorkspacesQuery()

  if (loading) {
    return <Spinner />
  }

  const categoryTree = buildWorkspaceCategoryTree(data?.workspaces)

  const CategoryAccordionItem = ({ category }) => (
    <Box mb="4px">
      <NavigationWorkspaceCategoryItem
        category={category}
        hideNavigation={hideNavigation}
      />
    </Box>
  )

  return (
    <>
      <Box className="Navigation__sectionTitle">
        {data?.workspaces?.length > 0 && <Trans>Workspaces</Trans>}
        <AdminOnlyAllowed allowManagerAccess>
          <CreateWorkspaceButtonModal hideNavigation={hideNavigation} />
        </AdminOnlyAllowed>
      </Box>

      <Box mt="8px">
        {categoryTree?.categories.map((category) => (
          <CategoryAccordionItem
            category={category}
            key={`nav-category-${category.id}`}
          />
        ))}

        {categoryTree?.workspacesWithoutCategories.length > 0 && (
          <>
            {categoryTree?.categories.length > 0 && (
              <Box className="Navigation__sectionTitle">
                <Trans>Other workspaces</Trans>
              </Box>
            )}

            {categoryTree?.workspacesWithoutCategories.map((workspace) => (
              <WorkspaceAccordionItem
                hideNavigation={hideNavigation}
                key={`nav-workspace-${workspace.id}`}
                workspace={workspace}
              />
            ))}
          </>
        )}
      </Box>
    </>
  )
}
